// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2wnTP","author":"Table_author__3upi7","authorImage":"Table_authorImage__3aJ3k","unreadRow":"Table_unreadRow__3BY_3"};